import React, { forwardRef, ReactElement } from 'react'
import { Icon, IconBase, IconWeight, IconProps as PhosphorIconProps } from '@phosphor-icons/react'
import { useTheme } from '../../themes/styled'

const getWeights = (color?: string, fillColor?: string) => {
    const svg: ReactElement = (
        <>
            <g clipPath="url(#clip0_14418_341)">
                <path
                    d="M84.2675 171.73L29.1775 151.43C27.6584 150.87 26.3478 149.857 25.422 148.528C24.4963 147.2 24 145.619 24 144C24 142.381 24.4963 140.801 25.422 139.472C26.3478 138.144 27.6584 137.131 29.1775 136.57L84.2675 116.27L104.567 61.1803C105.128 59.6612 106.141 58.3506 107.469 57.4248C108.798 56.4991 110.378 56.0028 111.997 56.0028C113.617 56.0028 115.197 56.4991 116.525 57.4248C117.854 58.3506 118.867 59.6612 119.427 61.1803L139.727 116.27L194.817 136.57C196.337 137.131 197.647 138.144 198.573 139.472C199.499 140.801 199.995 142.381 199.995 144C199.995 145.619 199.499 147.2 198.573 148.528C197.647 149.857 196.337 150.87 194.817 151.43L139.727 171.73L119.427 226.82C118.867 228.339 117.854 229.65 116.525 230.576C115.197 231.501 113.617 231.998 111.997 231.998C110.378 231.998 108.798 231.501 107.469 230.576C106.141 229.65 105.128 228.339 104.567 226.82L84.2675 171.73Z"
                    stroke={color}
                    strokeWidth="16"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    fill={fillColor}
                />
                <path d="M176 16V64" stroke={color} strokeWidth="16" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M224 72V104" stroke={color} strokeWidth="16" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M152 40H200" stroke={color} strokeWidth="16" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M208 88H240" stroke={color} strokeWidth="16" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_14418_341">
                    <rect width="256" height="256" fill="white" />
                </clipPath>
            </defs>
        </>
    )
    return new Map<IconWeight, ReactElement>([
        ['regular', svg],
        ['fill', svg],
    ])
}

/**
 * Phosphor custom icon based on https://github.com/phosphor-icons/react#custom-icons
 * Modified how color works to match the icon design
 */
interface IconProps extends PhosphorIconProps {
    fillColor?: string
}

const Sparkles: Icon = forwardRef<SVGSVGElement, IconProps>((props, ref) => {
    const theme = useTheme()
    return (
        <IconBase
            ref={ref}
            {...props}
            weights={getWeights(props.color, props.fillColor ? props.fillColor : theme.colors.indicator.lavenderPurple)}
            fill="None"
        />
    )
})

Sparkles.displayName = 'Sparkles'

export default Sparkles
